import React from 'react'
import { Link } from 'react-router-dom'
import { makeStyles } from "@mui/styles";
import { Helmet } from 'react-helmet';
import styles from "../assets/jss/material-kit-react/views/componentsSections/basicsStyle.js";
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles(styles);

const NotFound = () => {
  const { t } = useTranslation(['translation']);
  const classes = useStyles();
  return (
    <div className={classes.sections}>
      {/* Keep unmatched URLs out of the index. The web server answers unknown
          SPA routes with the application shell and HTTP 200, so this tag is
          the only signal a crawler gets that the route does not exist. */}
      <Helmet>
        <title>{t('Page_not_found')} - WecoBook</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className={classes.container}>
        <div className={classes.title}>
          <h1>{t('Error')}</h1>
        </div>
        <p>{t('Page_not_found')} <Link to='/'>{t('to_home_page')}</Link></p>
      </div>
    </div>
  )
}

export default NotFound